import { LitElement, html, css } from 'lit';

class ToujouTextClamper extends LitElement {
  static get is() {
    return 'toujou-text-clamper';
  }

  static get properties() {
    return {
      maxLines: {
        type: Number,
        attribute: 'max-lines',
      },
      expanded: {
        type: Boolean,
        reflect: true,
        attribute: 'expanded',
      },
      clamped: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  static get styles() {
    return css`
      :host {
        display: block;
      }
    `;
  }

  constructor() {
    super();
    this.showContent = false;
  }

  _handleSlotChange() {
    const slottedContent = this.shadowRoot.querySelector('#content');
    const content = slottedContent.assignedNodes({ flatten: true })
      .filter(el => el.className === 'toujou-text-clamper__content');

    const firstP = content[0].querySelector('*:first-child');
    const lineHeight = parseInt(window.getComputedStyle(firstP).getPropertyValue('line-height'), 10);
    const elementHeight = this.offsetHeight;
    this.maxHeight = lineHeight * this.maxLines;
    this.style.setProperty('--toujou-text-clamper-max-height', this.maxHeight);
    this.clamped = elementHeight > this.maxHeight;
  }

  _handleButtonClick() {
    this.expanded = !this.expanded;
  }

  render() {
    return html`
      <slot id="content" @slotchange="${this._handleSlotChange}"></slot>
      ${this.clamped ? html`<slot name="clamper-button" @click="${this._handleButtonClick}"></slot>` : ''}
    `;
  }
}

customElements.define(ToujouTextClamper.is, ToujouTextClamper);
